import { MapFlow } from '../map.flow';
import { InitialLocationCallback } from '../../map-container/map-initial-location.provider';

export class MapInitialFlow extends MapFlow {
  public override activate() {
    // Do nothing
  }

  public override deactivate() {
    // Do nothing
  }

  public override getInitialLocation(_successCallback: InitialLocationCallback) {
    // Do nothing
  }

  public override markersWereUpdated() {
    // Do nothing
  }
}
